// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1cpPj","header":"MergedInvoice_header__aYFq1"};